import * as Helper from '../helpers/helper';

export default class homeFilter {
    constructor() {
        if (document.getElementsByClassName('home-page')[0]) {
            this.initElements();
            this.initEvents();
        }
    }

    initElements() {
        this.datepicker = null;
        this.dateInput = document.getElementById('date-input');

        this.selectGenres = document.getElementById('select-genre');
        this.selectLoc = document.querySelector('#select-loc');

        const url = new URL(window.location.href);
        this.params = url.searchParams;
        this.queryParams = new URLSearchParams(window.location.search);
    }

    initEvents() {
        this.makeDatePicker();

        document.addEventListener('timePeriodCardSelected', (e) => {
            e.preventDefault();
            this.datepicker.clear();
            const selectedCard = this.datepicker.ui.shadowRoot.querySelector('.time-period-card-'+e.detail.slug);
            this.datepicker.ui.shadowRoot.querySelector('.period-search-selected')?.classList.remove('period-search-selected');
            selectedCard?.classList.add('period-search-selected');
            this.dateInput.setAttribute('placeholder', selectedCard.getAttribute('data-title'));
            this.dateInput.setAttribute('data-url', selectedCard.getAttribute('data-slug'));
        });

        document.getElementsByClassName('search-bar')[0].addEventListener('submit', (event) => {
            event.preventDefault();

            this.setParams();
        });
    }

    makeDatePicker() {
        if (document.getElementsByClassName('date-input')[0]) {
            this.datepicker = Helper.getDatePicker();
            document.getElementById('date-filter').addEventListener('click', () => {
                this.datepicker.show();
            });

            this.datepicker.on('click', (e => {
                e.stopPropagation(); // Otherwise, it triggers the date-filter click event.
            }));

            const url = new URL(window.location.href);
            const split = url.searchParams.get("dates")?.split(' ⟶ ');
            if (split) {
                this.dateInput.setAttribute('data-url', '');
                this.datepicker.setDateRange(split[0], split[1]);
            }
        }
    }

    setParams() {
        let term = document.getElementsByClassName('search-input')[0].value;
        if (term) {
            this.params.set('q', term);
            this.queryParams.set('q', term);
        } else {
            this.params.delete('q');
        }

        if (this.dateInput.value) {
            this.params.set('dates', this.dateInput.value);
        } else {
            this.params.delete('dates');
        }

        // localisation
        const location = this.selectLoc.querySelector('.selected');
        let locationValue;
        if (location) {
            locationValue = location.getAttribute('data-value');
            if (locationValue === 'near') {
                this.params.set('canton', locationValue);
                locationValue = null;
            }
        } else {
            this.params.delete('canton');
        }

        // genre
        const genre = this.selectGenres.querySelector('.selected');
        let genreValue;
        if (genre) {
            genreValue = genre.getAttribute('data-value');
        } else {
            this.params.delete('genre');
        }

        let timePeriodValue = this.dateInput.getAttribute('data-url');

        let baseUri;
        if (genreValue || locationValue || timePeriodValue) {
            baseUri = window.location.href + (genreValue ? '/' + genreValue : '') + (locationValue ? '/' + locationValue : '') + (timePeriodValue ? '/' + timePeriodValue : '')
        } else {
            baseUri = document.getElementsByTagName('form')[0].action;
        }

        const params = this.params.toString();
        window.location = baseUri + (params ? '?' + this.params.toString() : '');
    }
}
